/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import React from "react";
import { Navigate } from "react-router-dom";
import { readStoredAuthToken } from "../utils/sessionUser";

const PrivateRoute = ({ children }) => {
  const token = readStoredAuthToken();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
